
// twc.js
// ===== Header wrapper overlay =====
(function(){

  const header = document.querySelector('.header-wrapper');
  console.log(header);
  if (header) {
    header.classList.add("header-wrapper--overlay","is-light")
    console.log('headerwrapper')
  };

});

// ===== Membership tabs — mobile-only filtering (no inline display) =====
(function(){
  const section = document.querySelector('#membership');
  if(!section) return;

  const tabs = Array.from(section.querySelectorAll('.tabs .tab'));
  const cards = Array.from(section.querySelectorAll('.features-grid .feature'));
  const mq = window.matchMedia('(max-width: 767px)');

  function setActiveTab(tab){
    tabs.forEach(t => {
      const isActive = t === tab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', String(isActive));
      t.tabIndex = isActive ? 0 : -1;
    });
  }

  function filterByColumn(col){
    // Mobile: show only selected column
    if(mq.matches){
      cards.forEach(card => {
        const matches = card.classList.contains('col-' + col);
        card.classList.toggle('is-hidden', !matches);
        card.toggleAttribute('hidden', !matches);
      });
    }else{
      // Desktop: show all
      cards.forEach(card => {
        card.classList.remove('is-hidden');
        card.removeAttribute('hidden');
      });
    }
  }

  function handleTabClick(e){
    const btn = e.currentTarget;
    const col = btn.getAttribute('data-col');
    setActiveTab(btn);
    filterByColumn(col);
  }

  // Bind events
  tabs.forEach(btn => btn.addEventListener('click', handleTabClick));

  // Keyboard support for tabs (Left/Right/Home/End)
  section.querySelector('.tabs').addEventListener('keydown', (e) => {
    const idx = tabs.findIndex(t => t.classList.contains('is-active'));
    let next = idx;
    if(e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
    if(e.key === 'ArrowLeft')  next = (idx - 1 + tabs.length) % tabs.length;
    if(e.key === 'Home') next = 0;
    if(e.key === 'End')  next = tabs.length - 1;
    if(next !== idx){
      e.preventDefault();
      tabs[next].click();
      tabs[next].focus();
    }
  });

  // Respond to viewport changes
  mq.addEventListener('change', () => {
    if(mq.matches){
      // entering mobile: ensure an active tab filters
      const active = section.querySelector('.tabs .tab.is-active') || tabs[0];
      setActiveTab(active);
      filterByColumn(active.getAttribute('data-col'));
    }else{
      // entering desktop: clear filters and aria-hidden
      filterByColumn(null);
    }
  });

  // Initial state
  const initial = section.querySelector('.tabs .tab.is-active') || tabs[0];
  setActiveTab(initial);
  filterByColumn(initial.getAttribute('data-col'));
})();
// ===== Responsive video embed (YouTube/Vimeo/MP4) with background/player modes =====
(function(){
  const BP_MOBILE = 1023; // change to 393 or Motion’s breakpoint if you prefer
  const embeds = document.querySelectorAll('.video-embed');
  if (!embeds.length) return;

  // Grab a YouTube video ID from various URL shapes (shorts, watch, embed)
  function ytIdFrom(url){
    try {
      const u = new URL(url);
      if (u.hostname.includes('youtu.be')) return u.pathname.slice(1);
      if (u.pathname.startsWith('/shorts/')) return u.pathname.split('/')[2];
      if (u.searchParams.get('v')) return u.searchParams.get('v');
      if (u.pathname.startsWith('/embed/')) return u.pathname.split('/')[2];
    } catch(e){}
    return null;
  }

  function isMobile(){ return window.matchMedia(`(max-width:${BP_MOBILE}px)`).matches; }

  function setAspect(el){
    const aspect = isMobile()
      ? (el.getAttribute('data-aspect-mobile') || el.getAttribute('data-aspect-desktop') || '16/9')
      : (el.getAttribute('data-aspect-desktop') || '16/9');
    el.style.setProperty('--aspect', aspect);
  }

  function buildYoutubeSrc(id, mode){
    if (!id) return null;
    const base = `https://www.youtube.com/embed/${id}`;
    const common = [
      'playsinline=1',
      'modestbranding=1',
      'rel=0',
      'iv_load_policy=3'
    ];
    if (mode === 'background'){
      // Muted autoplay loop with minimal UI
      common.push(
        'autoplay=1','mute=1','controls=0','fs=0','disablekb=1',
        'loop=1',`playlist=${id}`
      );
    } else {
      // Player with controls & sound (useful for Founder video)
      common.push('controls=1','autoplay=0','mute=0');
    }
    return `${base}?${common.join('&')}`;
  }

  function hydrate(el){

    if (el.classList.contains('is-loaded')) return;

    const mode = (el.getAttribute('data-mode') || 'player').toLowerCase();
    const srcDesktop = el.getAttribute('data-src-desktop') || '';
    const srcMobile  = el.getAttribute('data-src-mobile')  || srcDesktop;
    const chosen     = isMobile() ? srcMobile : srcDesktop;
    const provider   = (el.getAttribute('data-provider') || '').toLowerCase();
    const title      = el.getAttribute('data-title') || 'Video';

    setAspect(el);

    let node = null;

    if (provider === 'youtube'){
      const id = ytIdFrom(chosen);
      const src = buildYoutubeSrc(id, mode);
      if (!src) return;

      node = document.createElement('iframe');
      node.src = src;
      node.title = title;
      node.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      node.allowFullscreen = true;
      node.loading = 'lazy';
      node.referrerPolicy = 'no-referrer-when-downgrade';
    } else if (provider === 'vimeo'){
      // Vimeo suggestion (best for true background with no branding):
      // background=1&autoplay=1&muted=1&loop=1&controls=0&dnt=1
      // (implement similar to YouTube if you switch to Vimeo)
      return;
    } else if (provider === 'mp4'){
      node = document.createElement('video');
      node.src = chosen;
      node.playsInline = true;
      node.preload = 'metadata';
      if (mode === 'background'){
        node.muted = true; node.autoplay = true; node.loop = true; node.controls = false;
      } else {
        node.controls = true;
      }
    } else {
      return;
    }

    el.appendChild(node);
        if ((el.getAttribute('data-fit') || '').toLowerCase() === 'cover') {
        attachCoverResizer(el, node);
        }
    el.classList.add('is-loaded');
  }

  // Lazy-load: background videos hydrate immediately on intersection,
  // player videos can still be lazy via intersection, or you can add a play button.
  const io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            hydrate(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' })
    : null;

  embeds.forEach(el => {
    setAspect(el);
    const mode = (el.getAttribute('data-mode') || 'player').toLowerCase();
    if (mode === 'background'){
      // Don’t wait for a click—load as soon as near viewport
      if (io) io.observe(el); else hydrate(el);
    } else {
      // Player mode: still lazy-load on view; if you add a custom play button,
      // you can hydrate on click instead.
      if (io) io.observe(el); else hydrate(el);
    }
  });

  // Keep reserved height correct before hydration if user resizes
  let t;
  window.addEventListener('resize', () => {
    clearTimeout(t); t = setTimeout(() => {
      document.querySelectorAll('.video-embed:not(.is-loaded)').forEach(setAspect);
    }, 120);
  });
})();






    

    // Distillery progress
    (() => {
      const scroller = document.getElementById('distillery-gallery');
      const filled = document.getElementById('distillery-progress-filled');
      if (!scroller || !filled) return;
      const update = () => {
        const max = scroller.scrollWidth - scroller.clientWidth;
        const pct = max > 0 ? scroller.scrollLeft / max : 0;
        const trackW = filled.parentElement.clientWidth;
        filled.style.width = (trackW * pct) + 'px';
      };
      scroller.addEventListener('scroll', update, { passive: true });
      addEventListener('resize', update);
      update();
    })();
// ===== Reusable Accordion =====
// - Mobile (<= breakpoint): first open by default; single-open enforced per accordion
// - Desktop (> breakpoint): if container has "always-open-desktop", force all open and ignore toggles
(function () {
  const ACCORDION_SELECTOR = '.accordion';
  const ITEM_SELECTOR = '.accordion__item';
  const SUMMARY_SELECTOR = '.accordion__summary';

  const accordions = document.querySelectorAll(ACCORDION_SELECTOR);
  if (!accordions.length) return;

  accordions.forEach(initAccordion);

  function initAccordion(acc) {
    const bp = parseInt(acc.dataset.breakpoint || '450', 10);
    const mq = window.matchMedia(`(max-width:${bp}px)`);
    const items = () => Array.from(acc.querySelectorAll(ITEM_SELECTOR));

    const isAlwaysOpenDesktop = () =>
      acc.classList.contains('accordion--always-open-desktop') ||
      acc.dataset.alwaysOpenDesktop === 'true';

    // Ensure first is open on mobile if none are open
    function ensureFirstOpenOnMobile() {
      const list = items();
      if (!list.length) return;
      if (!list.some(d => d.open)) list[0].open = true;
    }

    // On mobile: when one opens, close others in THIS accordion
    function handleToggleMobile(e) {
      const d = e.target;
      if (!(d instanceof HTMLDetailsElement)) return;
      if (!mq.matches) return;        // only on mobile
      if (!d.open) return;            // only act when opening

      items().forEach(other => {
        if (other !== d) other.open = false;
      });
    }

    // On desktop with "always-open-desktop": keep everything open, ignore summary clicks
    function preventDesktopClose(e) {
      if (mq.matches) return; // only desktop behavior here
      if (!isAlwaysOpenDesktop()) return;

      const sum = e.target.closest(SUMMARY_SELECTOR);
      if (!sum) return;

      // Prevent toggling <details> when clicking the summary
      e.preventDefault();
      const d = sum.closest('details');
      if (d && !d.open) d.open = true; // just in case
    }

    // Apply state based on viewport
    function applyMode() {
      const mobile = mq.matches;

      if (mobile) {
        // If multiple open from server/desktop state, keep only the first open
        const open = items().filter(d => d.open);
        if (open.length > 1) open.slice(1).forEach(d => (d.open = false));
        ensureFirstOpenOnMobile();
      } else {
        if (isAlwaysOpenDesktop()) {
          items().forEach(d => (d.open = true));
        }
        // else: desktop FAQ-like behavior (allow multiple open)
      }
    }

    // Event listeners scoped to this accordion
    acc.addEventListener('toggle', handleToggleMobile, true);
    acc.addEventListener('click', preventDesktopClose, true);

    // Respond to breakpoint changes
    (mq.addEventListener ? mq.addEventListener('change', applyMode) : mq.addListener(applyMode));

    // Initial run
    applyMode();
  }
})();
function fitIframeCover(container, iframe) {
  // Always treat YouTube player as 16:9
  const R = 16 / 9;
  const rect = container.getBoundingClientRect();
  const W = rect.width, H = rect.height;
  const containerRatio = W / H;

  // Center
  iframe.style.top = '50%';
  iframe.style.left = '50%';
  iframe.style.transform = 'translate(-50%, -50%)';

  if (containerRatio > R) {
    // Container is wider than 16:9 → fit width, grow height
    const width = W;
    const height = W / R;
    iframe.style.width = width + 'px';
    iframe.style.height = height + 'px';
  } else {
    // Container is taller/narrower → fit height, grow width
    const height = H;
    const width = H * R;
    iframe.style.width = width + 'px';
    iframe.style.height = height + 'px';
  }
}

function attachCoverResizer(container, iframe) {
  const ro = ('ResizeObserver' in window) ? new ResizeObserver(() => fitIframeCover(container, iframe)) : null;
  function onResize(){ fitIframeCover(container, iframe); }
  if (ro) ro.observe(container); else window.addEventListener('resize', onResize);
  // Initial fit after the iframe is in DOM
  requestAnimationFrame(() => fitIframeCover(container, iframe));
}
  function init(el){
    setAspect(el);
    const btn = el.querySelector('.video-play');
    if (btn){
      btn.addEventListener('click', () => hydrate(el), { once:true });
      // keyboard access
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); hydrate(el); }
      }, { once:true });
    }
  }
  // ===== Simple, accessible accordion =====
(function(){
  const groups = document.querySelectorAll('[data-accordion-group]');

  function isMobile(){ return matchMedia('(max-width: 1023px)').matches; }

  function closePanel(btn, panel){
    if (!panel || panel.hidden) return;
    btn.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  }
  function openPanel(btn, panel){
    if (!panel || !panel.hidden) return;
    btn.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
  }

  groups.forEach(group => {
    const closeOthers = (group.getAttribute('data-accordion-close-others') || 'true') === 'true';
    const items = group.querySelectorAll('[data-accordion]');

    items.forEach(item => {
      const btn   = item.querySelector('[aria-controls]');
      const panel = btn ? document.getElementById(btn.getAttribute('aria-controls')) : null;
      if (!btn || !panel) return;

      // start closed everywhere; we’ll open first on mobile below
      btn.setAttribute('aria-expanded','false');
      panel.hidden = true;

      btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';

        if (closeOthers && !isOpen){
          // close only siblings in the same group
          items.forEach(sib => {
            if (sib === item) return;
            const b = sib.querySelector('[aria-controls]');
            const p = b ? document.getElementById(b.getAttribute('aria-controls')) : null;
            if (b && p) closePanel(b,p);
          });
        }
        isOpen ? closePanel(btn,panel) : openPanel(btn,panel);
      });

      // keyboard (optional: Enter/Space handled by button natively)
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp'){
          e.preventDefault();
          const list = Array.from(items).map(i => i.querySelector('[aria-controls]')).filter(Boolean);
          const idx = list.indexOf(btn);
          const next = e.key === 'ArrowDown' ? (idx+1) % list.length : (idx-1+list.length) % list.length;
          list[next].focus();
        }
      });
    });

    // First panel open on mobile by default
    const first = items[0];
    if (first && isMobile()){
      const b = first.querySelector('[aria-controls]');
      const p = b ? document.getElementById(b.getAttribute('aria-controls')) : null;
      if (b && p){ openPanel(b,p); }
    }

    // keep the “first open on mobile” rule when resizing across breakpoint
    let t;
    window.addEventListener('resize', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        if (!first) return;
        const b = first.querySelector('[aria-controls]');
        const p = b ? document.getElementById(b.getAttribute('aria-controls')) : null;
        if (!b || !p) return;

        if (isMobile()){
          // ensure at least first is open
          const anyOpen = Array.from(items).some(i => {
            const bb = i.querySelector('[aria-controls]');
            return bb && bb.getAttribute('aria-expanded') === 'true';
          });
          if (!anyOpen) openPanel(b,p);
        } else {
          // desktop default: all closed
          items.forEach(i => {
            const bb = i.querySelector('[aria-controls]');
            const pp = bb ? document.getElementById(bb.getAttribute('aria-controls')) : null;
            if (bb && pp) closePanel(bb,pp);
          });
        }
      },120);
    });
  });
})();
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('form.js-ajax-add').forEach(function(form){
    // Initialise Motion's AJAX add-to-cart handler on each form
    new theme.AjaxProduct(form, '.add-to-cart');
  });
});
// ===== Smooth Scroll helper =====
(function () {
  const SCROLL_OFFSET = 90; // adjust for fixed header height

  // Listen for clicks on any link with .js-scroll or data-scroll
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.twc-js-scroll, [data-scroll-twc]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#')) return;

    const target = document.querySelector(href);
    if (!target) return;

    e.preventDefault();

    const y = target.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  const switches = document.querySelectorAll('.giftSwitch');

  if (!switches.length) return;

  // Listen on every switch
  switches.forEach(sw => {
    sw.addEventListener('change', () => {
      const isGift = sw.checked;

      // 1. Sync all other switches
      switches.forEach(other => {
        if (other.checked !== isGift) {
          other.checked = isGift;
        }
      });

      // 2. Update all forms everywhere
      const idInputs = document.querySelectorAll('.payment-cta__form input[name="id"]');

      idInputs.forEach(input => {
        const giftId = input.dataset.gift;
        const payId = input.dataset.pay;
        input.value = isGift ? giftId : payId;
      });
    });
  });

  // Sync form inputs on page load in case browser restored checkbox state (bfcache / back button)
  const initialState = switches[0].checked;
  if (initialState) {
    document.querySelectorAll('.payment-cta__form input[name="id"]').forEach(input => {
      const giftId = input.dataset.gift;
      if (giftId) input.value = giftId;
    });
  }
});